import { render, staticRenderFns } from "./ApplyAlter.vue?vue&type=template&id=81a83c74"
import script from "./ApplyAlter.vue?vue&type=script&lang=js"
export * from "./ApplyAlter.vue?vue&type=script&lang=js"
import style0 from "./ApplyAlter.vue?vue&type=style&index=0&id=81a83c74&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports